export default "/dist/fonts/Exo2-BoldItalic.ttf";